angular.module('eCareVault.authentication', []);